import { faker } from '@faker-js/faker';

import { coerceBoolean, objectValues, random } from '@hsp/utilities';

import { defaultMockTime, Uri } from 'constants/index';
import { IClient } from 'types/api/client';
import { IClientList } from 'types/api/client-list';
import { IDataContainer, IResult } from 'types/api/common';

import { BaseHttpService } from './http/base-http.service';

class ClientService extends BaseHttpService {
  constructor() {
    super({ endpoints: objectValues(Uri.Client) as string[] });
  }

  getClientLists(clients: string, cancel = false): Promise<IResult<IDataContainer<IClientList[]>>> | undefined {
    const url = Uri.Client.ClientLists;

    return this.get({
      params: { clients },
      signal: cancel ? this.cancellations[url].onCancellation().signal : undefined,
      url,
      withCredentials: true,
    });
  }

  getClients(cancel = false): Promise<IResult<IDataContainer<IClient[]>>> | undefined {
    const url = Uri.Client.Clients;

    return this.get({
      signal: cancel ? this.cancellations[url].onCancellation().signal : undefined,
      url,
      withCredentials: true,
    });
  }
}

export const clientService = new ClientService();

if (coerceBoolean(process.env.REACT_APP_API_CLIENT_FAKE)) {
  const mocked = clientService.mock(defaultMockTime);
  const mock = mocked?.adapter;

  mock?.onGet(Uri.Client.Clients).reply((): Promise<[number, IResult<IDataContainer<IClient[]>>]> => {
    return new Promise((resolve) => {
      const data: IClient[] = [];

      Array.from({ length: random(100) }).forEach(() => {
        data.push({
          acronym: faker.datatype.string(4),
          id: faker.datatype.uuid(),
          isInactive: faker.datatype.boolean(),
          name: faker.company.name(),
        });
      });

      const result: IResult<IDataContainer<IClient[]>> = {
        dataContainer: { data },
        failure: false,
        statusCode: 200,
        success: true,
      };

      resolve([200, result]);
    });
  });

  mock?.onGet(Uri.Client.ClientLists).reply((): Promise<[number, IResult<IDataContainer<IClientList[]>>]> => {
    return new Promise((resolve) => {
      const data: IClientList[] = [];

      Array.from({ length: random(100) }).forEach(() => {
        data.push({
          clientAcronym: faker.datatype.string(4),
          code: faker.datatype.string(4),
          id: faker.datatype.uuid(),
          name: faker.company.name(),
          projectId: faker.datatype.number(2),
        });
      });

      const result: IResult<IDataContainer<IClientList[]>> = {
        dataContainer: { data },
        failure: false,
        statusCode: 200,
        success: true,
      };

      resolve([200, result]);
    });
  });
}
